export const EVENT_TAG_MAP = {
  LV1_TAG: 1, // 添加lv1埋点信息
}

const strategyEventConf = {
  [EVENT_TAG_MAP.LV1_TAG]: [
    'sailing_c_x_shop_common_sw',
    'sailing_c_x_shop_item2cart_ck',
    'sailing_c_x_specselection_item2cart_ck',
  ]
}
const strategyEventMap = {};

const keys = Object.keys(strategyEventConf);
keys.forEach(key => {
  strategyEventConf[key].forEach(item => {
    strategyEventMap[item] = key
  })
})

export default strategyEventMap;
